import {
	IMobileScansListQuery,
	IMobileScansListRawRow,
	IMobileScansListResult,
	IMobileScansListRow,
	MobileScansProductType
} from '../MobileScansList.types';

const EMPTY_SUMMARY = {
	scansCount: 0,
	issuesCount: 0,
	elementsWithIssuesCount: 0
};

const isMobileScansListRawRow = (
	scan: IMobileScansListRawRow | null
): scan is IMobileScansListRawRow => !!scan;

export const transformMobileScansListResults = (
	rawResults: IMobileScansListQuery,
	productName: MobileScansProductType | undefined
): IMobileScansListResult => {
	const rows: IMobileScansListRow[] =
		(rawResults.mfa_scans_list ?? rawResults.msdk_scans_list)
			?.filter(isMobileScansListRawRow)
			.map((scan) => ({
				productName: productName as MobileScansProductType,
				runId: scan.run_id,
				scanId: scan.scan_id,
				scanName: scan.scan_name,
				scanCreatedAt: scan.scan_created_at,
				scanScreenshotUrl: scan.scan_screenshot_url,
				totalIssues: scan.total_issues,
				criticalIssues: scan.critical_issues,
				seriousIssues: scan.serious_issues,
				elementsWithIssues: scan.elements_with_issues
			})) ?? [];

	const summaryResult = rawResults.total?.[0];
	const summary = summaryResult
		? {
				scansCount: summaryResult.scan_id_count ?? 0,
				issuesCount: summaryResult.total_issues_sum ?? 0,
				elementsWithIssuesCount: summaryResult.elements_with_issues_sum ?? 0
			}
		: EMPTY_SUMMARY;

	return {
		rows,
		total: summary.scansCount,
		summary
	};
};
